import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  modalTitle: {
    id: 'portal.components.userEditPopup.title',
    defaultMessage: 'Edit Profile Information',
    description: 'Modal title',
  },
  fullNameLabel: {
    id: 'portal.components.userEditPopup.field.fullName.label',
    defaultMessage: 'Full Name',
    description: 'Full Name field label',
  },
  fullNameEmptyError: {
    id: 'portal.components.userEditPopup.field.fullName.error.empty',
    defaultMessage: 'Full Name is required',
    description: 'Full Name field empty alert message',
  },
  displayOnProfileLabel: {
    id: 'portal.components.userEditPopup.displayOnProfile.flag.label',
    defaultMessage: 'Display on profile',
    description: 'Display on profile flag label',
  },
  fullNameTooLongError: {
    id: 'portal.components.userEditPopup.field.fullName.error.tooLong',
    defaultMessage: 'Full Name must be less than 255 characters',
    description: 'Full Name too long error',
  },
  titleLabel: {
    id: 'portal.components.userEditPopup.field.title.label',
    defaultMessage: 'Title',
    description: 'Title field label',
  },
  titleTooLongError: {
    id: 'portal.components.userEditPopup.field.title.error.tooLong',
    defaultMessage: 'Title must be less than 255 characters',
    description: 'Title too long error',
  },
  aboutLabel: {
    id: 'portal.components.userEditPopup.field.about.label',
    defaultMessage: 'About',
    description: 'About field label',
  },
  aboutTooLongError: {
    id: 'portal.components.userEditPopup.field.about.error.tooLong',
    defaultMessage: 'About must be less than 300 characters',
    description: 'About too long error',
  },
  linkedInLabel: {
    id: 'portal.components.userEditPopup.field.linkedIn.label',
    defaultMessage: 'LinkedIn',
    description: 'LinkedIn field label',
  },
  xSocialLabel: {
    id: 'portal.components.userEditPopup.field.x.label',
    defaultMessage: 'X.com',
    description: 'X (formerly Twitter) field label',
  },
  socialLinkTooLongError: {
    id: 'portal.components.userEditPopup.field.socialLink.error.tooLong',
    defaultMessage: 'Social link must be less than 100 characters',
    description: 'Social link too long error',
  },
  cancelButton: {
    id: 'portal.components.userEditPopup.cancel.button.text',
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
  },
  saveButton: {
    id: 'portal.components.userEditPopup.save.button.text',
    defaultMessage: 'Save & Exit',
    description: 'Save & Exit button text',
  },
  updateSuccess: {
    id: 'portal.components.userEditPopup.update.success.message',
    defaultMessage: 'Profile Updated Successfully',
    description: 'Update success alert message',
  },
  errorOccurred: {
    id: 'portal.components.userEditPopup.update.errorOccurred.message',
    defaultMessage: 'An Error Occurred. Please try again later',
    description: 'Error occurred alert message',
  },
  invalidSocialLink: {
    id: 'portal.components.userEditPopup.field.socialLink.error.invalid',
    defaultMessage: 'Please provide a valid {platform} link',
    description: 'Error message for invalid social link',
  },
});

export default messages;
